import { useAuthState } from "react-firebase-hooks/auth";
import { getAuth } from "firebase/auth";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useEffect, useState } from "react";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import { AddUserRequestData, ProjectRole } from "../../types/firestore";
import { FirebaseError } from "firebase/app";
import firebaseErrors from "../../modules/firebaseErrors";
import Spinner from "react-bootstrap/Spinner";
import { getFunctions, httpsCallable } from "firebase/functions";

const functions = getFunctions();
const auth = getAuth();

export interface AddMemberProps {
	projectId: string;
}

export default function AddMember(props: AddMemberProps) {
	const [saving, setSaving] = useState(false);
	const [error, setError] = useState<string>();

	const [user] = useAuthState(auth);

	const [showAddMember, setShowAddMember] = useState(false);

	const [memberEmail, setMemberEmail] = useState("");
	const [memberRole, setMemberRole] = useState<ProjectRole | -1>(-1);

	useEffect(() => {
		if (!showAddMember) return;
		setMemberEmail("");
		setMemberRole(-1);
		setError(undefined);
	}, [showAddMember]);

	if (!user) return <div></div>;

	return (
		<div>
			<Button variant="success" onClick={() => setShowAddMember(true)}>
				<i className="bi bi-plus-circle" /> Mitglied hinzufügen
			</Button>
			<Modal
				show={showAddMember}
				onHide={() => !saving && setShowAddMember(false)}
				backdrop="static"
				keyboard={false}>
				<Modal.Header closeButton>
					<Modal.Title>Mitglied hinzufügen</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<FloatingLabel label="Email-Adresse" className="mb-2">
						<Form.Control
							type="email"
							placeholder="Email-Adresse"
							value={memberEmail}
							onChange={(e) => setMemberEmail(e.target.value)}
						/>
					</FloatingLabel>

					<FloatingLabel label="Rolle" className="mb-2">
						<Form.Select
							value={memberRole}
							onChange={(e) => setMemberRole(Number.parseInt(e.target.value))}>
							<option value={-1}>Rolle auswählen</option>
							<option value={ProjectRole.Admin}>Administrator</option>
							<option value={ProjectRole.Driver}>Fahrer</option>
						</Form.Select>
					</FloatingLabel>

					{error && <div className="mb-2 text-danger">{error}</div>}
				</Modal.Body>
				<Modal.Footer>
					<Button
						disabled={!showAddMember || saving}
						variant="danger"
						onClick={() => setShowAddMember(false)}>
						Abbrechen
					</Button>
					<Button
						variant="success"
						disabled={!showAddMember || saving || memberEmail === "" || memberRole === -1}
						onClick={async () => {
							if (memberRole === -1) return;

							console.log(memberRole);

							setSaving(true);
							setError(undefined);

							const addUser = httpsCallable<AddUserRequestData, void>(functions, "project-addUser");

							try {
								await addUser({
									projectId: props.projectId,
									userEmail: memberEmail,
									userRole: memberRole,
								});

								setSaving(false);
								setShowAddMember(false);
							} catch (error) {
								if (error instanceof FirebaseError) {
									setSaving(false);

									const message = firebaseErrors[error.code] ?? error.message;

									setError(message);
									return;
								}

								throw error;
							}
						}}>
						{saving && <Spinner className="me-1" animation="border" size="sm" />}
						Hinzufügen
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
}
